<template>
    <div class="bg">
        <div class="content">
            <div class="info">
                <span>{{name}}</span>
            </div>
            <div class="score-wrap" id="">
                <div :class="item.check==1?'item':'item1'" v-for="(item,index) in this.scores" v-bind:key="index" @click="toChoose(index)" :id="index">
                    <span>{{item.score}}</span>
                </div>
            </div>
            <div class="submit" :class="score!=0?'submit_enable':'submit_disable'" @click="toSubmit">
                <span>{{submit}}</span>
            </div>
        </div>

    </div>
</template>

<script>
    import {getVotePlayer,voteScore,getBrowserScore} from "@/assets/js/api";
    import Fingerprint2 from 'fingerprintjs2'
    export default {
        name: "Host",
        data(){
            return{
                name:"选手姓名",
                hos:"所在单位",
                scores:[
                        {score:80,check:0},
                        {score:85,check:0},
                        {score:90,check:0},
                        {score:95,check:0}],
                submit:"提交",
                playerId:this.$route.query.playerId,
                score:0,
                disabled:false,
                browserPrinter:null

            }
        },
        methods:{
            toSubmit(){
                if(this.score==0){
                    if(!this.disabled){
                        this.$toast("-----请选择分数-------")
                    }else{
                        this.$toast("-----您已打分-------")
                    }

                }else{
                    // this.$toast("-----开始打分-------"+this.score)
                    this.toScore(this.playerId,this.score,this.browserPrinter)
                }
            },
            toChoose(index){
                if(this.disabled) return
                for(let i of this.scores){
                    i.check=0
                }
                this.scores[index].check=1
                this.score = this.scores[index].score
            },
            disable(){
                this.disabled = true
                for(let i of this.scores){
                    i.check=0
                }
                this.score = 0
            },
            async toGetPlayer(playerId){
                const res = await getVotePlayer({playerId})
                if(res.data.success){
                    this.name = res.data.data.name
                }
            },
            async toScore(playerId,score,browserPrinter){
                const res = await voteScore({playerId,score,browserPrinter})
                if(res.data.success){
                    this.$toast("提交成功")
                    this.disable()
                }else{
                    this.$toast(res.data.message)
                }
            },
            async toGetBrowserScore(playerId,browserPrinter){
               const res =  await getBrowserScore({playerId,browserPrinter});
                // console.log("------------getbrowserprintscpre-------------",res)
               if(res.data.success){//已经提交了
                   this.$toast("您已提交")
                   this.disable();
               }
            },
            getFingerPrint(){
                let _this = this
                Fingerprint2.get(function(components) {
                    const values = components.map(function(component,index) {
                        if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                            return component.value.replace(/\bNetType\/\w+\b/, '')
                        }
                        return component.value
                    })
                    // 生成最终id murmur
                    const murmur = Fingerprint2.x64hash128(values.join(''), 31);
                    console.log('浏览器指纹码：'+murmur )
                    _this.browserPrinter = murmur
                    if(_this.browserPrinter!=null){
                        _this.toGetBrowserScore(_this.playerId,_this.browserPrinter)
                    }
                })
            }
        },
        mounted(){
            this.toGetPlayer(this.playerId)
            this.getFingerPrint();
        },
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: #FFF url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/qkds/vote_score_bg.jpg") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
    }

    .score-wrap{
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        /*margin-top: 30px;*/
    }

    .item{
        width: 40%;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #0082C5;
        border-radius: 20px;
        margin: 5px;
        font-size: 40px;
        color: #FFF;
    }

    .item1{
        width: 40%;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #999;
        border-radius: 20px;
        margin: 5px;
        font-size: 40px;
        color: #555;
    }

    .info{
        /*background: #ddd;*/
        font-size: 35px;
        color: #0082C5;
        margin-bottom: 30px;
        span{
            font-weight: bold;
            display: block;
            margin: 10px 0;
        }
    }

    .hint{
        text-align: left;
        /*margin-top: 30px;*/
        font-size: 15px;
    }

    .submit{
        width: 90%;
        height: 50px;
        line-height: 50px;
        border-radius: 20px;
        margin: 40px auto;
        font-size: 25px;
        color: #FFF;
    }

    .submit_enable{
        background: #0082c5;
    }


    .submit_disable{
        background: #999;
    }

</style>